import React from 'react';
import uuid from 'uuid-random';
import { styled } from '@mui/system';
import StarIcon from 'assets/icons/star.svg?react';
import StarFilledIcon from 'assets/icons/star-filled.svg?react';

const Icon = styled(StarIcon)({
  width: 23,
  height: 23
});

const FilledIcon = styled(StarFilledIcon)({
  width: 23,
  height: 23
});

const RatingReview = ({ start = 5, rating, setRating }) => {
  const starsArray = Array.from({ length: start }, (_, i) => i + 1);

  return (
    <>
      {starsArray.map((star) => {
        return (
          <span
            key={uuid()}
            style={{
              cursor: setRating ? 'pointer' : 'default',
              marginRight: 5,
              height: '100%',
              display: 'inline-block'
            }}
            onClick={setRating ? () => setRating(star) : null}>
            {rating >= star ? <FilledIcon /> : <Icon />}
          </span>
        );
      })}
    </>
  );
};

export default RatingReview;
